import { axiosInstance } from '~/common/utils/api.util';

import type { PaginatedApiResponse } from '~/common/types/api.type';
import type {
  UserAccessHistory,
  UserAccessHistoryListParams,
} from '~/features/user-access-history/types/user-access-history.type';

/**
 * 사용자 접속 이력 목록 조회
 * @description 사용자 접속 이력 목록을 조회합니다
 * @endpoint GET /admin/user-access-histories
 * @param params - 조회 파라미터
 * @returns 접속 이력 목록 및 페이지네이션 정보
 */
export function getUserAccessHistoryListApi(params?: UserAccessHistoryListParams) {
  return axiosInstance.get<PaginatedApiResponse<UserAccessHistory>>(
    '/admin/user-access-histories',
    { params },
  );
}
